import { render } from "./MultiLingualInput.vue?vue&type=template&id=67573ede&scoped=true"
import script from "./MultiLingualInput.vue?vue&type=script&lang=js"
export * from "./MultiLingualInput.vue?vue&type=script&lang=js"

import "./MultiLingualInput.vue?vue&type=style&index=0&id=67573ede&scoped=true&lang=css"
import "./MultiLingualInput.vue?vue&type=style&index=1&id=67573ede&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67573ede"]])

export default __exports__